import React from "react";
import { useThemeStore } from "../stores/themeStore";
import { garminDeviceModel } from "../utils/providerAttribution";
import garminTagBlack from "../assets/wearable/garmin-tag-black.png";
import garminTagWhite from "../assets/wearable/garmin-tag-white.png";

interface GarminAttributionProps {
  deviceModel?: string | null;
  className?: string;
}

/**
 * Garmin logo with the device model beneath it — the attribution layout
 * Garmin's brand guidelines show for Activity API data.
 */
const GarminAttribution: React.FC<GarminAttributionProps> = ({ deviceModel, className = "" }) => {
  const isDark = useThemeStore((s) => s.resolvedTheme === "peakx-dark");
  const model = garminDeviceModel(deviceModel);

  return (
    <div className={`flex flex-col items-start gap-0.5 ${className}`}>
      <img src={isDark ? garminTagWhite : garminTagBlack} alt="Garmin" className="h-4 w-auto" />
      {model && <span className="text-xs text-base-content/60">{model}</span>}
    </div>
  );
};

export default GarminAttribution;
